import {
  csrfHeaders,
  parseResponse,
  requestQueue as sharedRequestQueue,
  requestSignal as sharedRequestSignal,
  undoSignal as sharedUndoSignal
} from "components/supplier_admin/shared/queue_polling";

const createNote = ({ shipmentId, body }) =>
  fetch(`/supplier/shipments/${shipmentId}/notes`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...csrfHeaders() },
    credentials: "same-origin",
    body: JSON.stringify({ body })
  }).then(response => parseResponse(response, "Printer queue note request failed."));

const requestQueue = state =>
  sharedRequestQueue("/supplier/printer_queue", state, "Printer queue request failed.");

const requestSignal = ({ shipmentId, signalType }) =>
  sharedRequestSignal({
    shipmentId,
    signalType,
    errorMessage: "Printer queue signal request failed."
  });

const undoSignal = ({ shipmentId, signalId }) =>
  sharedUndoSignal({
    shipmentId,
    signalId,
    errorMessage: "Printer queue undo signal request failed."
  });

export { createNote, requestQueue, requestSignal, undoSignal };
